import { render, staticRenderFns } from "./Mysign.vue?vue&type=template&id=490e7d52&scoped=true"
import script from "./Mysign.vue?vue&type=script&lang=js"
export * from "./Mysign.vue?vue&type=script&lang=js"
import style0 from "./Mysign.vue?vue&type=style&index=0&id=490e7d52&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e7d52",
  null
  
)

export default component.exports